import React from "react";
import { Helmet } from "react-helmet-async";

const BASE_URL = "https://www.lyonphotopro.fr";
const DEFAULT_IMG = `${BASE_URL}/images/imageLogo.webp`;

function SEO({ title, description, path = "", image = DEFAULT_IMG }) {
  const fullTitle = title
    ? `${title} | Alexandre Jack — Photographe Lyon`
    : "Alexandre Jack — Photographe professionnel à Lyon | Cliché";
  const url = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}

export default SEO;
